/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVIcon16Solid = forwardRef('DataChartBarsXyVIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 2a1 1 0 0 0-2 0v10.5A2.5 2.5 0 0 0 2.5 15h12a1 1 0 1 0 0-2h-12a.5.5 0 0 1-.5-.5V2Z" }),
        React.createElement("path", { d: "M13 1a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M8 4a1 1 0 0 0-2 0v7a1 1 0 1 0 2 0V4Z" }),
        React.createElement("path", { d: "M10 5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M4 7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Z" })));
});
